import { FetchError, ToastStateHandler } from '../../../api';
import { LocalStorage, ACCESS_TOKEN, ID_TOKEN } from '../../../util/LocalStorage';
import { GlobalApi } from '../../../util/Global';
import { AppConfig } from '../../../config/AppConfig';
import { useTranslation } from '../../useTranslation';

interface HttpAddCompanyLogoOptions {
    storage: LocalStorage;
    toastHandler: ToastStateHandler;
    globalApi: GlobalApi;
}

const useHttpAddCompanyLogo = ({ storage, toastHandler, globalApi }: HttpAddCompanyLogoOptions) => {
    const { t } = useTranslation('newNotifications');

    const exec = async (image: File, callback: { onSuccess?: (data: any) => void }) => {
        const headers = new Headers();
        const accessToken = storage.get(ACCESS_TOKEN);
        const idToken = storage.get(ID_TOKEN);

        if (!accessToken || !idToken) {
            globalApi.href('/sign-in');
            return;
        }
        headers.append('X-Id-Token', idToken);
        headers.append('Authorization', `Bearer ${accessToken}`);

        const formdata = new FormData();
        formdata.append('image', image, image.name);

        const requestOptions: RequestInit = {
            method: 'POST',
            headers: headers,
            body: formdata,
            redirect: 'follow',
        };

        try {
            const res = await fetch(`${AppConfig.serverUrlBase}/org/v1/organization/-addcompanyLogo`, requestOptions);
            const data = await res.json();
            if (!res.ok) throw new FetchError(res.status, res.ok, data?.fault?.message || data?.message || 'Error');
            if (callback.onSuccess) callback.onSuccess(data.body);
            toastHandler.push('success', t('organization.companyLogoUploadTitle'), t('organization.companyLogoUploadMessage_Success'));
        } catch (e: any) {
            toastHandler.push('error', t('organization.companyLogoUploadTitle'), t('organization.companyLogoUploadMessage_Failed'));
        }
    };

    return { exec };
};

export default useHttpAddCompanyLogo;
